import { DatePicker, Input, Select, Tag } from "antd";
import { debounce, firstLetterCaps, getFromWorkspace, hasAllKeys } from "../../helpers/helper";
import apiAction from "../../ajax/service";
import { useEffect, useState } from "react";
import { setAgreementFilters, setEventFilters, setInvoiceFilters, setRentalFilters, setTenantFilters, setLeadsFilters } from "../../features/rentSlice";
import { setCalendarFilters } from "../../features/calendarSlice";
import { useSelector } from "react-redux";
import { getFromPreload } from "../../helpers/helper";
import { resolveType } from "../../helpers/resolvers";
var config = {
  dashboard: {
    name: {
      dataField: "name__contains",
      type: "Text",
    },
    type: {
      type: "Select",
      dataField: "type",
      dataSource: "workspace.types",
    },
    startDate: {
      dataField: "createdAt__gte",
      type: "DatePicker",
    },
    showArchived: {
      dataField: "archived",
      type: "Select",
      dataSource:"preload.constants.yes_no"
    },
  },
  agreement: {

    startDate: {
      dataField: "startDate__gte",
      type: "DatePicker",
    },
    endDate: {
      dataField: "endDate__lte", // fixed __
      type: "DatePicker",
    },
  },
  calendar: {
    name: {
      dataField: "name__contains",
      type: "Text",
    },
    type: {
      type: "Select",
      dataField: "type",
      dataSource: "workspace.types",
    },
  },
  tenants: {
    name: {
      dataField: "name__contains",
      type: "Text",
    },
    email: {
      dataField: "email__contains",
      type: "Text",
    },
    showArchived: {
      dataField: "archived",
      type: "Select",
      dataSource:"preload.constants.yes_no"
    },
  },
  leads: {
    name: {
      dataField: "name__contains",
      type: "Text",
    },
    email: {
      dataField: "email__contains",
      type: "Text",
    },
    converted: {
      type: "Select",
      dataField: "converted",
      dataSource: "preload.constants.yes_no",
    },
     showArchived: {
      dataField: "archived",
      type: "Select",
      dataSource:"preload.constants.yes_no"
    },
  },
  events: {
    name: {
      dataField: "name__contains",
      type: "Text",
    },
    startDate: {
      dataField: "startDate__gte",
      type: "DatePicker",
    },
    endDate: {
      dataField: "endDate__lte",
      type: "DatePicker",
    },
     showArchived: {
      dataField: "archived",
      type: "Select",
      dataSource:"preload.constants.yes_no"
    },
  },
};

const setFilters = (dispatch, view, key, value) => {

  switch (view) {
    case 'dashboard': {
      dispatch(setRentalFilters({ key, value }))
      break
    }
    case 'agreement': {
      dispatch(setAgreementFilters({ key, value }))
      break
    }
    case 'invoice': {
      dispatch(setInvoiceFilters({ key, value }))
      break
    }
    case 'calendar': {
      dispatch(setCalendarFilters({ key, value }))
      break
    }
    case 'tenants': {
      dispatch(setTenantFilters({ key, value }))
      break
    }
    case 'leads': {
      dispatch(setLeadsFilters({ key, value }))
      break
    }
    case 'events': {
      dispatch(setEventFilters({ key, value }))
      break
    }

    }
  }
const Filters = ({ dispatch, filterPage = "dashboard",  values , vertical = false }) => {
  const preload = useSelector(state=>state.workspace.preload)
  const workspaceData = useSelector(state=>state.workspace)
  const filterStyle = {
    width: "auto",
    margin: 5,
  };

  const [refresh, setRefresh] = useState(0)

  useEffect(() => {
    setRefresh(refresh + 1)
  }, [preload])

  return (
    <div style={!vertical ? { padding: 10 }:{}}>
      {" "}
      <span>Filters :</span>
      {Object.keys(config[filterPage]).map((item) => {

        const type = config[filterPage][item]["type"];
        const dataField = config[filterPage][item]["dataField"];
        const dataSource = config[filterPage][item]?.["dataSource"]
        let data = []
        if (dataSource) {
          data = config[filterPage][item]?.["data"]
        }
        if (typeof dataSource === 'string' && dataSource != "static" ){

          if (!('fetched' in config[filterPage][item])){
            if (dataSource.startsWith("preload")){
            const value = getFromPreload(preload ,dataSource)

            config[filterPage][item]['data'] = value
            if (value)
            config[filterPage][item]['fetched'] = true


          } else if(dataSource.startsWith("workspace")){
            const value = getFromWorkspace(workspaceData,dataSource,"select")
            if (value.length){
            config[filterPage][item]['data'] = value
            config[filterPage][item]['fetched'] = true
            setRefresh(refresh+1)
            }
          }
          else {
          apiAction('filters',{field : dataSource} , 'getUniqueInField').then((value)=>{
            config[filterPage][item]['data'] = value.data ? value['data'] : value
            config[filterPage][item]['fetched'] = true
            setRefresh(refresh+1)
          }).catch(()=>{
            config[filterPage][item]['fetched'] = true
            setRefresh(refresh+1)
          })
        }
        }
        }
        if (type === "Text") {
          return (
            <Input
              id={`filter-${item}`}
              key={`input-${dataField}`}
              style={{ cursor: 'text', ...filterStyle }}
              placeholder={firstLetterCaps(item)}
              value={values?.[dataField]}
              onChange={

                (e) => {
                  debounce(setFilters(dispatch, filterPage, dataField, e.target.value))
                }
              }
            />
          );
        } else if (type === "DatePicker") {
          return (
            <DatePicker
            id={`filter-${item}`}
              key={`datepicker-${dataField}`}
              value={values?.[dataField]}
              style={{ maxWidth: 120, ...filterStyle }}
              placeholder={firstLetterCaps(item, true)}
              onChange={(val) => setFilters(dispatch, filterPage, dataField, val)}
            />
          );
        } else if (type === "Select") {
          return (
            <Select
              allowClear
              id={`filter-${item}`}
              value={values?.[dataField]}
              key={`select-${dataField}`}
              style={{ minWidth: 150, ...filterStyle }}
              options={
                dataSource == "static"
                  ? data
                  : data?.map((item) => {
                      if (typeof item === "object") {
                        if (hasAllKeys(item,["key","label","value"])){
                          return item
                        }
                        const [[key, value , label]] = Object.entries(item);
                        return {
                          key: key,
                          label: label ? label : value,
                          value: value ? value :  key
                        };
                      }
                      return {
                        key: item,
                        label: item,
                        value: item.toLowerCase() == "yes" ? true : false,
                      };
                    })
              }
              onChange={(val) =>
                setFilters(dispatch, filterPage, dataField, val)
              }
              placeholder={firstLetterCaps(item, true)}
            />
          );
        }
      })}
    </div>
  );
};

export default Filters;
